import Backbone from 'backbone';

const DashboardLinkView = Backbone.View.extend({
  initialize(options) {
    const settings = options.settings;
    const url = [
      'http://buildingdashboard.net',
      settings.orgUrlElement,
      settings.facilityUrlElement,
    ].join('/');
    this.$el.attr('href', url);
  },
});

export default DashboardLinkView;
